export type Currency = 'ZMW' | 'USD' | 'ZAR' | 'EUR' | 'GBP';
export type ModeOfPayment = 'Cash' | 'Cheque' | 'BankTransfer' | 'MobileMoney'

export interface CurrencyOption {
  label: string;
  value: string;
}

export const CURRENCY_OPTIONS: CurrencyOption[] = [
  { label: 'Zambian Kwacha', value: 'ZMW' },
  { label: 'South African Rand', value: 'ZAR' },
  { label: 'US Dollar', value: 'USD' },
  { label: 'British Pound', value: 'GBP' },
  { label: 'Euro', value: 'EUR' },
];
